export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            投稿爆料
          </h2>
          <p className="text-sm text-foreground-500 mt-2">有料你就来！欢迎广大瓜友投稿爆料</p>
        </div>

        <div className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-10 max-w-3xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-mail-send-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">邮箱投稿</h3>
              <p className="text-xs text-foreground-500">tips@51daily.news</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                <i className="ri-wechat-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">微信投稿</h3>
              <p className="text-xs text-foreground-500">添加客服：51dailytips</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">在线提交</h3>
              <p className="text-xs text-foreground-500">填写爆料表单，24h内回复</p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200">
            <p className="text-xs text-foreground-500 text-center leading-relaxed">
              我们承诺对所有投稿信息严格保密。爆料内容一经采用，将根据热度给予相应奖励。
              投稿即视为同意授权51每日大赛发布，投稿人享有匿名保护。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}